// Initial tracker data - will be stored in Supabase
export const INITIAL_DATA = {
  lastUpdated: new Date().toISOString(),
  
  debt: {
    atInauguration: 36.18,
    baseline: 38.43,
    baselineDate: '2026-01-07T00:00:00Z',
    perSecond: 92912.33,
    perHousehold: 285127,
    source: 'Joint Economic Committee / Treasury Dept',
  },
  
  wealth: {
    current: 6.5,
    previous: 2.3,
    rank: 645,
    source: 'Forbes',
    breakdown: [
      { category: 'Cryptocurrencies', value: 7.1, note: 'Up to (NYT July 2025)' },
      { category: 'Stocks, Bonds & Cash', value: 2.2 },
      { category: 'Real Estate & Business', value: 1.3 },
      { category: 'Debts', value: -0.64 },
    ],
  },
  
  golf: {
    golfClubVisits2025: 88,
    totalPropertyVisits: 99,
    estimatedCost2025: 110600000,
    costPerMarALagoTrip: 3400000,
    costPerBedminsterTrip: 1100000,
    scotlandTripCost: 10000000,
    firstTermTotal: 151500000,
    firstTermVisits: 261,
    secretServiceToTrump: 2000000,
    secretServiceToTrump2ndTerm: 100000,
    source: 'GAO 2019 Report • CREW • HuffPost • Trump Golf Tracker',
    sourceUrl: 'https://www.citizensforethics.org/reports-investigations/crew-investigations/secret-service-has-spent-nearly-100k-at-trump-properties/',
  },
  
  selfDealing: {
    secretServiceAtProperties2ndTerm: 100000,
    secretServiceFirstTerm: 2000000,
    foreignGovFirstTerm: 7800000,
    foreignCountries: 20,
    overchargeRate: '300%',
    cryptoFees: 427000000,
    source: 'CREW • House Oversight • GAO • American Oversight',
    sourceUrl: 'https://www.citizensforethics.org/reports-investigations/crew-reports/trumps-term-2-corruption-by-the-numbers-more-golf-trips-more-foreign-visitors-and-more-profits/',
  },
  
  iceVictims: [
    { 
      id: 'renee-good',
      name: 'Renée Good', 
      age: 37, 
      citizenship: 'US Citizen',
      date: 'January 7, 2026',
      location: 'Minneapolis, MN',
      agency: 'ICE',
      details: 'Shot by ICE agent Jonathan Ross while in her vehicle during "Operation Metro Surge." Mother of a 6-year-old. Video shows agent filming with phone before shooting.',
      officialResponse: 'DHS claims self-defense',
      witnessAccount: 'Mayor Frey: "narrative that this was done in self-defense is garbage"',
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Killing_of_Renee_Good' },
        { name: 'CNN', url: 'https://www.cnn.com/2026/01/17/us/ice-shooting-minneapolis-renee-good' },
        { name: 'NBC News', url: 'https://www.nbcnews.com/news/us-news/renee-nicole-good-minneapolis-ice-shooting-victim-caring-neighbor-rcna252901' },
        { name: 'Washington Post', url: 'https://www.washingtonpost.com/investigations/2026/01/09/moments-before-ice-shooting-minneapolis/' },
      ],
    },
    { 
      id: 'alex-pretti',
      name: 'Alex Pretti', 
      age: 37, 
      citizenship: 'US Citizen',
      date: 'January 24, 2026',
      location: 'Minneapolis, MN',
      agency: 'Border Patrol',
      details: 'ICU nurse at VA hospital. Shot while observing immigration enforcement. Bystander video shows him helping a woman who was pushed down, then being tackled and shot 4 times in the back.',
      officialResponse: 'DHS claims he "tried to assassinate federal law enforcement"',
      witnessAccount: 'Sworn statements say he did not brandish gun, was helping woman get up',
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Killing_of_Alex_Pretti' },
        { name: 'MPR News', url: 'https://www.mprnews.org/story/2026/01/24/second-shooting-minneapolis-ice-protests' },
        { name: 'CBS News', url: 'https://www.cbsnews.com/minnesota/news/alex-pretti-shooting-minneapolis-ice-protest/' },
      ],
    },
  ],
  
  iceStats: {
    totalShootings: 33,
    shootingDeaths: 9,
    usCitizensKilled: 2,
    usCitizensShot: 5,
    detentionDeaths2025: 32,
    detentionDeaths2026: 6,
    note: 'December 2025 was deadliest month on record. 2025 had highest ICE detention deaths since 2004.',
    source: 'Wikipedia / ACLU / Vera Institute / NBC News / PBS',
    sourceUrl: 'https://en.wikipedia.org/wiki/List_of_shootings_by_U.S._immigration_agents_in_the_second_Trump_administration',
  },

  environmentStats: {
    rollbacksTotal: 440,
    rollbacksPeriod: '14 months',
    acresLostFromMonuments: 2000000,
    epaBudgetCurrent: 3.2,
    epaBudgetHistorical: 8.0,
    epaBudgetCut: 65,
    drillingPermitIncrease: 470,
    coalMined2025: 125,
    cleanEnergyCreditsRepealed: 425,
    source: 'NRDC, Columbia Law, Harvard Law, EPA, CBO',
    sourceUrl: 'https://www.nrdc.org/trump-rollbacks-tracker',
  },

  brokenPromises: [
    {
      id: 'groceries-down',
      category: 'Economy',
      promise: 'Bring grocery prices "way down"',
      quote: '"I won on groceries. I won an election based on that."',
      datePromised: 'December 2024',
      location: 'Meet the Press',
      deadline: 'Ongoing',
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 0,
      reality: [
        'Grocery prices UP ~2% year-over-year (Feb 2026) — still climbing',
        'Trump admitted to Time magazine: bringing prices down will be "very hard"',
        'Coffee up 20%, ground beef up 15.5%, eggs spiked then resurged',
        'Food prices hit record highs on Day 365 — BLS data contradicts all claims',
      ],
      sources: ['CNN Fact Check', 'BLS', 'ABC News', 'PolitiFact', 'Washington Times'],
    },
    {
      id: 'manufacturing-jobs',
      category: 'Economy',
      promise: 'Manufacturing jobs "roaring back"',
      quote: '"Jobs and factories will come roaring back into our country."',
      datePromised: 'April 2, 2025',
      location: 'Liberation Day tariff announcement',
      deadline: null,
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 0,
      reality: [
        'Lost 108,000 manufacturing jobs in Year 1 (Senate JEC analysis)',
        'Manufacturing employment declined every month since April 2025',
        'Manufacturing construction spending down 8.8% ($250B → $202B)',
        '2025 manufactured goods trade deficit UP $62B vs 2024',
      ],
      sources: ['Senate JEC', 'Washington Post', 'CBS News', 'Yahoo Finance'],
    },
    {
      id: 'energy-50',
      category: 'Economy',
      promise: 'Cut energy bills in HALF within 12 months',
      quote: '"I will cut your energy and electricity prices in half, 50% — 5-0 — within 12 months of taking the oath"',
      datePromised: 'August 14, 2024',
      location: 'Asheville, NC rally',
      deadline: 'January 20, 2026',
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 20,
      reality: [
        'Gasoline: Down ~20% (not 50%) - global oil prices, not policy',
        'Electricity: UP 9% from January to August 2025',
        'Average family paid $124 MORE for utilities since inauguration',
        'Household energy costs 6.2% higher year-over-year',
      ],
      sources: ['NPR', 'CNN Fact Check', 'BLS', 'EIA'],
    },
    {
      id: 'ukraine-24h',
      category: 'Foreign Policy',
      promise: 'End Ukraine war within 24 HOURS',
      quote: '"I\'ll get that done within 24 hours. Everyone says, \'Oh, no, you can\'t.\' Absolutely I can."',
      datePromised: 'July 2023 - November 2024',
      location: '53+ times at rallies',
      deadline: 'January 21, 2025',
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 0,
      reality: [
        'War continues after 417+ days in office',
        'Trump now says it was "in jest" and "an exaggeration" — CNN documented 53 serious statements',
        'Extended deadline: 24 hours → 100 days → 6 months → indefinite',
        'Geneva talks Feb 2026: no deal reached; Zelenskyy refused to cede occupied territory',
      ],
      sources: ['CNN (53 instances documented)', 'Time Magazine', 'PolitiFact', 'NBC News'],
    },
    {
      id: 'no-new-wars',
      category: 'Foreign Policy',
      promise: 'No new wars — "I will prevent WWIII"',
      quote: '"I will prevent World War III. Under Biden, we are closer to World War III than at any time in history. I will never let that happen."',
      datePromised: '2024 campaign',
      location: 'Multiple rallies and RNC speech',
      deadline: null,
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 0,
      reality: [
        'Feb 2026: Ordered coordinated U.S.–Israel strikes on Iran — 6 U.S. soldiers killed',
        'March 2025: Launched largest U.S. military assault on Yemen in decades (Operation Rough Rider)',
        'Military draft declared "on the table" by administration officials (March 2026)',
        'Threatened military force to seize Greenland from Denmark, a NATO ally',
        'Threatened military takeover of Panama Canal',
      ],
      sources: ['Reuters', 'AP', 'CNN', 'CBS News', 'Military.com', 'CFR'],
    },
    {
      id: 'end-gaza-war',
      category: 'Foreign Policy',
      promise: 'End the war in Gaza before inauguration',
      quote: '"If I win, I will have the Gaza war settled before I even get to the Oval Office."',
      datePromised: 'September 2024',
      location: 'Fox News interview',
      deadline: 'January 20, 2025',
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 15,
      reality: [
        'War continued past inauguration; ceasefire brokered Oct 2025 — Phase 2 now stalled',
        '442+ Palestinians killed since ceasefire talks stalled (Jan 2026)',
        'Phase 2 negotiations suspended as Trump admin pivots to Iran war',
        'Proposed relocating Gazans to Egypt/Jordan — condemned as ethnic cleansing',
      ],
      sources: ['AP', 'NPR', 'CNN', 'CFR', 'The Soufan Center'],
    },
    {
      id: 'day-one-inflation',
      category: 'Economy',
      promise: 'End inflation on DAY ONE',
      quote: '"Starting on day one, we will end inflation and make America affordable again"',
      datePromised: 'August 9, 2024',
      location: 'Bozeman, MT rally',
      deadline: 'January 20, 2025',
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 0,
      reality: [
        'CPI accelerated to 3.0% after taking office (up from 2.9%)',
        'Eggs spiked 15.2% in one month (Jan 2025)',
        'Groceries: 2.7% increase - largest non-pandemic gain since 2015',
        'Goldman Sachs: Consumers bearing 50%+ of tariff costs',
      ],
      sources: ['BLS', 'Newsweek', 'CNN', 'Goldman Sachs'],
    },
    {
      id: 'epstein-files',
      category: 'Transparency',
      promise: 'Release the Epstein files',
      quote: '"I guess I would [release the Epstein files]"',
      datePromised: 'June 2024',
      location: 'Fox & Friends, Lex Fridman Podcast',
      deadline: 'No specific date given',
      status: 'MOSTLY BROKEN',
      statusColor: '#ff6600',
      progress: 30,
      reality: [
        'Administration resisted release for months',
        'Congress forced his hand with 427-1 vote (Epstein Files Transparency Act)',
        'DOJ MISSED legal deadline (December 19, 2025)',
        '5.2 million pages still unreviewed as of late December',
        'Released files show Trump flew on Epstein plane 8 times (more than known)',
      ],
      sources: ['NPR', 'Axios', 'CNBC', 'Wikipedia'],
    },
    {
      id: 'medicare-medicaid',
      category: 'Healthcare',
      promise: 'Protect Medicare and Medicaid - NO CUTS',
      quote: '"I will never do anything that will jeopardize or hurt Social Security or Medicare"',
      datePromised: 'Multiple interviews 2024',
      location: 'Various',
      deadline: null,
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 0,
      reality: [
        '"One Big Beautiful Bill" erased 12 years of Medicare solvency — fund now exhausted by 2040',
        'Medicaid work requirements (80+ hrs/month) projected to strip millions of coverage',
        'Let ACA marketplace tax credits lapse — premiums spiked 50%+ for millions',
        'Treasury Secretary Bessent: bill is "backdoor for privatizing Social Security"',
      ],
      sources: ['CBS News', 'Reuters', 'Fortune', 'FactCheck.org', 'AFSCME'],
    },
    {
      id: 'protect-social-security',
      category: 'Economy',
      promise: 'Protect Social Security — "We\'re not going to touch it"',
      quote: '"We\'re not going to do anything with Social Security, Medicare, Medicaid. We\'re not going to touch it."',
      datePromised: 'Multiple interviews 2024',
      location: 'Various',
      deadline: null,
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 0,
      reality: [
        'DOGE cut 7,000+ SSA employees (12% of workforce) — worst staffing in 60 years',
        '1 SSA employee now serves 1,480 beneficiaries — 3× the 1967 ratio',
        'Deaths awaiting disability determination at highest rate since Eisenhower signed the program',
        'Beneficiaries can no longer apply by phone in most cases — must appear in person',
      ],
      sources: ['Fox News', 'CBPP', 'AFGE', 'The Mirror'],
    },
    {
      id: 'tariffs-pay-everything',
      category: 'Economy',
      promise: 'Tariff revenue to replace income tax / fund everything',
      quote: '"I believe at some point in the not too distant future, you won\'t even have income tax to pay because the money we\'re taking in is so great"',
      datePromised: 'December 2025',
      location: 'Various interviews',
      deadline: null,
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 5,
      reality: [
        'Promised ~$6T in tariff-funded programs; 2025 revenue: $264B',
        'Income tax raised $2.7T in 2025 vs $264B tariffs',
        'Tariffs cover <5% of promised expenditures',
        'Washington Post: promises exceed 22x actual tariff revenue',
      ],
      sources: ['Washington Post', 'Treasury', 'Cato Institute'],
    },
    {
      id: 'lower-costs-day-one',
      category: 'Economy',
      promise: 'Make America affordable again on Day One',
      quote: '"Starting on day one, we will end inflation and make America affordable again, to bring down the prices of all goods"',
      datePromised: 'August 9, 2024',
      location: 'Bozeman, MT rally',
      deadline: 'January 20, 2025',
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 0,
      reality: [
        'Households paid $2,120 MORE in 2025 due to inflation (Warren Report)',
        'Bottom 20% of households hit hardest (5%+ of income)',
        'Electricity bills: +$123 | Groceries: +$150 per household',
        'Fed: Tariffs responsible for inflation rising above 2% target',
      ],
      sources: ['Senate Banking Committee', 'Fortune', 'Federal Reserve', 'Goldman Sachs'],
    },
    {
      id: 'jobs-coming-back',
      category: 'Economy',
      promise: 'Jobs coming back / best economy ever',
      quote: '"We\'re going to have the greatest economy in the history of the world"',
      datePromised: '2024 campaign',
      location: 'Multiple rallies',
      deadline: null,
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 0,
      reality: [
        '2025 saw lowest average monthly job growth since 2003 (excluding recessions)',
        'December 2025: Job gains cooled significantly',
        '57% of consumers expect economy to weaken in 2026 (Deloitte)',
        'Only 44% of Republicans rate economy as excellent/good (Bloomberg)',
      ],
      sources: ['WSJ', 'Bloomberg', 'MarketWatch', 'Deloitte'],
    },
    {
      id: 'no-deportation-errors',
      category: 'Immigration',
      promise: 'Only deport criminals, protect legal residents',
      quote: '"We\'re not looking to deport legal residents... we\'re looking for the bad ones, the criminals"',
      datePromised: '2024 campaign',
      location: 'Various',
      deadline: null,
      status: 'BROKEN',
      statusColor: '#ff3333',
      progress: 0,
      reality: [
        'Kilmar Abrego Garcia: Legal resident wrongfully deported to El Salvador prison',
        'Administration admitted "administrative error" but refused to return him',
        'Defied Supreme Court order to "facilitate" his return',
        'Now prosecuting him after failed challenge—court called it "vindictive"',
      ],
      sources: ['Supreme Court', 'PBS', 'CBS News', 'NPR'],
    },
  ],
  
  // Constitutional concerns - robust baseline with REAL article URLs
  constitutionalConcerns: [
    {
      id: 'defying-courts',
      amendment: 'ARTICLE III / SEPARATION OF POWERS',
      title: 'Defying 1 in 3 Court Orders',
      description: 'Washington Post analysis found the administration defied, delayed, or manipulated rulings in 57 of 165 lawsuits (roughly 1/3) where courts ruled against it—unprecedented for any presidential administration.',
      examples: [
        'Kilmar Abrego Garcia: Refused return despite Supreme Court order',
        'Continued deportation flights after temporary restraining orders',
        'Chief Judge Boasberg: "willful disregard" of court orders',
        'Judge Xinis: administration showed "no tolerance for compliance"',
      ],
      quote: 'The Constitution does not tolerate willful disobedience of judicial orders—especially by officials of a coordinate branch who have sworn an oath to uphold it.',
      quoteSource: 'Chief U.S. District Judge James E. Boasberg',
      status: 'ONGOING',
      statusColor: '#ef4444',
      sources: [
        { name: 'Washington Post', url: 'https://www.washingtonpost.com/politics/2025/03/17/trump-court-orders-defy-deportations/' },
        { name: 'Truthout', url: 'https://truthout.org/articles/trump-white-house-refuses-to-abide-by-1-in-3-court-orders-made-against-them/' },
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Immigration_policy_of_the_second_Trump_administration' },
      ],
    },
    {
      id: 'due-process',
      amendment: '5TH & 14TH AMENDMENTS',
      title: 'Deportations Without Due Process',
      description: '225+ judges have ruled in 700+ cases that mandatory immigration detention policy likely violates law and the right to due process. Legal residents deported without hearings.',
      examples: [
        'Abrego Garcia: Deported to foreign prison without hearing despite legal status',
        'F-1 visa students: 100+ lawsuits over revocations without process',
        'New detention policy deprives opportunity for immigration court hearings',
        'Citizens detained by federal agents without identification procedures',
      ],
      quote: 'No person shall be... deprived of life, liberty, or property, without due process of law.',
      quoteSource: 'Fifth Amendment',
      status: 'ONGOING - 700+ RULINGS',
      statusColor: '#f59e0b',
      sources: [
        { name: 'Washington Post', url: 'https://www.washingtonpost.com/immigration/2025/08/29/trump-deportation-expedited-removal/' },
        { name: 'NPR', url: 'https://www.npr.org/2025/12/23/g-s1-103001/trump-immigration-deportation-migration-legal-status' },
        { name: 'ACLU', url: 'https://www.aclu.org/news/immigrants-rights/the-trump-administration-is-attacking-immigration-on-every-front' },
      ],
    },
    {
      id: 'birthright-citizenship',
      amendment: '14TH AMENDMENT',
      title: 'Birthright Citizenship Executive Order',
      description: 'EO 14160 attempts to deny citizenship to U.S.-born children—contradicting 14th Amendment text and 127 years of Supreme Court precedent (U.S. v. Wong Kim Ark, 1898).',
      examples: [
        'Blocked by multiple federal courts',
        'Supreme Court hearing expected Feb-Apr 2026',
        'ACLU, LULAC, and states filed immediate lawsuits',
        '6-3 Supreme Court limited injunctions to named plaintiffs only',
      ],
      quote: 'All persons born or naturalized in the United States, and subject to the jurisdiction thereof, are citizens of the United States.',
      quoteSource: 'Fourteenth Amendment, Section 1',
      status: 'IN COURTS - SCOTUS 2026',
      statusColor: '#3b82f6',
      sources: [
        { name: 'SCOTUSblog', url: 'https://www.scotusblog.com/case-files/cases/trump-v-casa/' },
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Executive_Order_14160' },
        { name: 'ACLU', url: 'https://www.aclu.org/press-releases/aclu-challenges-trump-birthright-citizenship-order' },
      ],
    },
    {
      id: 'emoluments',
      amendment: 'ARTICLE I, SECTION 9',
      title: 'Foreign Emoluments Without Congressional Consent',
      description: 'Trump Organization revised ethics policy in 2025 to explicitly allow foreign transactions. Qatar plane deal ($7M+), foreign government hotel stays, and business deals continue without congressional consent.',
      examples: [
        '$7.8M from 20+ foreign governments documented during first term',
        'Qatar plane deal: Senate resolution calls it "illegal emolument"',
        'Vietnam: $1.5B golf complex fast-tracked during tariff negotiations',
        'Serbia: Half-billion-dollar Trump Hotel cleared after election',
      ],
      quote: 'No Person holding any Office of Profit or Trust under them, shall, without the Consent of the Congress, accept of any present, Emolument, Office, or Title, of any kind whatever, from any King, Prince, or foreign State.',
      quoteSource: 'Foreign Emoluments Clause',
      status: 'NO CONGRESSIONAL CONSENT',
      statusColor: '#22c55e',
      sources: [
        { name: 'CREW', url: 'https://www.citizensforethics.org/reports-investigations/crew-investigations/president-trump-exposed-to-174-foreign-government-payments/' },
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Title_of_Nobility_Clause' },
        { name: 'Brennan Center', url: 'https://www.brennancenter.org/our-work/research-reports/foreign-emoluments-clause-primer' },
      ],
    },
    {
      id: 'first-amendment',
      amendment: '1ST AMENDMENT',
      title: 'Attacks on Press and Protesters',
      description: 'Two U.S. citizens shot by federal agents at immigration protests. Multiple lawsuits from AP, NPR, PBS over press access bans. Calls to revoke broadcast licenses of critical networks.',
      examples: [
        'AP sued over Oval Office/Air Force One bans for using "Gulf of Mexico"',
        'NPR, PBS sued over funding threats',
        'Two citizens killed by federal agents at Minneapolis protests',
        'Journalists face access revocation for critical coverage',
      ],
      quote: 'Congress shall make no law... abridging the freedom of speech, or of the press; or the right of the people peaceably to assemble.',
      quoteSource: 'First Amendment',
      status: 'MULTIPLE LAWSUITS',
      statusColor: '#8b5cf6',
      sources: [
        { name: 'CPJ', url: 'https://cpj.org/2025/04/trumps-first-100-days-portend-long-lasting-damage-to-press-freedom/' },
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Freedom_of_the_press_in_the_United_States' },
        { name: 'PEN America', url: 'https://pen.org/campaign/press-freedom-under-threat-in-the-united-states/' },
      ],
    },
    {
      id: 'doge-unconstitutional',
      amendment: 'ARTICLE I / SEPARATION OF POWERS',
      title: 'DOGE Mass Firings Without Congressional Authorization',
      description: 'Federal judge ruled OPM illegally directed mass firings of 25,000+ probationary employees. Congress established agencies; administration closing them without authorization.',
      examples: [
        '352,000 federal workforce reduction in 2025 (OPM/Federal News Network)',
        'Judge Alsup: OPM firings were unlawful',
        'USAID, Education Dept, HHS gutted without congressional approval',
        'Supreme Court stayed reinstatement orders, allowing cuts to continue',
      ],
      quote: 'OPM does not have any authority whatsoever under any statute in the history of the universe to hire and fire employees within another agency.',
      quoteSource: 'Federal Judge William Alsup',
      status: 'RULED ILLEGAL - SCOTUS ALLOWED',
      statusColor: '#ef4444',
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Department_of_Government_Efficiency' },
        { name: 'NPR', url: 'https://www.npr.org/2025/02/14/nx-s1-5262683/doge-elon-musk-federal-workers-cuts/' },
        { name: 'Government Executive', url: 'https://www.govexec.com/oversight/2025/05/government-oversight-employees-detail-fears/405465/' },
      ],
    },
    {
      id: 'equal-protection',
      amendment: '14TH AMENDMENT - EQUAL PROTECTION',
      title: 'Political Discrimination in Federal Grants',
      description: 'Court ruled DOE cancelled clean energy grants based on whether recipients lived in states that voted for Trump—"purposeful segregation based on electoral support."',
      examples: [
        'Jan 12, 2026: DC District Court rules unconstitutional',
        '"No explanation for how segregation advances government interest"',
        'Grants cancelled in non-Trump states; approved in Trump states',
        'Environmental Defense Fund lawsuit successful',
      ],
      quote: 'Defendants freely admit that they made grant-termination decisions primarily — if not exclusively — based on whether the awardee resided in a state whose citizens voted for President Trump in 2024.',
      quoteSource: 'U.S. District Court, D.C. (Jan 12, 2026)',
      status: 'RULED UNCONSTITUTIONAL',
      statusColor: '#ef4444',
      sources: [
        { name: 'Columbia Law', url: 'https://climate.law.columbia.edu/climate-deregulation-tracker' },
        { name: 'Reuters', url: 'https://www.reuters.com/legal/government/' },
      ],
    },
    {
      id: 'j6-pardons',
      amendment: 'RULE OF LAW',
      title: 'Mass Pardons for Capitol Attack',
      description: 'Pardoned 1,500+ individuals convicted of January 6th crimes on first day in office, including seditious conspiracy convicts and those who assaulted 140+ police officers.',
      examples: [
        'Oath Keepers & Proud Boys leaders: seditious conspiracy sentences commuted',
        'Pardons for assault on police officers',
        'Judge Lamberth: "unconscionable" and "preposterous"',
        'DC Police Union condemned pardons',
      ],
      status: 'COMPLETED - DAY ONE',
      statusColor: '#ef4444',
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Pardons_by_Donald_Trump' },
        { name: 'NPR', url: 'https://www.npr.org/2025/01/20/nx-s1-5267498/trump-jan-6-pardons' },
        { name: 'AP News', url: 'https://apnews.com/article/trump-jan-6-pardons-capitol-riot-ec84e19cf50ac853d10f44bfc4b428f4' },
      ],
    },
    {
      id: 'inspector-general',
      amendment: 'CONGRESSIONAL OVERSIGHT',
      title: 'Illegal Firing of Inspectors General',
      description: 'Fired 17 Inspectors General without required 30-day congressional notice. Judge ruled firings unlawful but refused reinstatement.',
      examples: [
        'Sept 24, 2025: Judge Reyes ruled firings unlawful',
        'Required 30-day notice to Congress was not provided',
        'IGs provide independent oversight of executive agencies',
        'Court noted Trump would "simply re-fire them" after notice',
      ],
      status: 'RULED UNLAWFUL',
      statusColor: '#f59e0b',
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/2025_dismissals_of_U.S._inspectors_general' },
        { name: 'Government Executive', url: 'https://www.govexec.com/oversight/2025/09/fired-watchdogs-cant-be-reinstated/408387/' },
        { name: 'NPR', url: 'https://www.npr.org/2025/01/25/g-s1-44771/trump-fires-inspectors-general/' },
      ],
    },
  ],
  
  // Breaking news items - auto-updated by cronjob
  // Categories: epstein, ice, lawsuit, constitutional, poll, promise
  breakingNews: [
    {
      id: 'backfill-constitutional-20250120-1',
      category: 'constitutional',
      date: '2025-01-20',
      headline: "Trump signs executive order to end birthright citizenship",
      summary: "Within hours of his inauguration, President Trump signed an executive order aimed at ending the constitutional right to citizenship for individuals born in the United States to non-citizen parents. The move was immediately challenged in court by civil liberties groups as a violation of the 14th Amendment.",
      sources: [
        { name: 'TIME', url: 'https://time.com/7123164/donald-trump-second-term-timeline-2025/' },
        { name: 'American Civil Liberties Union', url: 'https://www.aclu.org/news/civil-liberties/one-year-in-defending-the-constitution-under-a-second-trump-administration' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20250121-1',
      category: 'constitutional',
      date: '2025-01-21',
      headline: "Trump issues executive order reinstating Schedule F",
      summary: "President Trump signed an executive order to reinstate \"Schedule F,\" a controversial job classification that would strip civil service protections from tens of thousands of federal employees in policy-related roles. The move makes it easier to fire career civil servants and replace them with political loyalists, raising concerns about the politicization of the federal workforce.",
      sources: [
        { name: 'The Guardian', url: 'https://www.theguardian.com/us-news/2025/jan/21/trump-schedule-f-federal-employees-easier-to-fire' },
        { name: 'Government Executive', url: 'https://www.govexec.com/workforce/2026/02/trump-admin-moves-finalize-return-schedule-f/393964/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20250124-1',
      category: 'constitutional',
      date: '2025-01-24',
      headline: "Trump fires 17 federal inspectors general in 'Friday Night Massacre'",
      summary: "The Trump administration abruptly fired at least 17 inspectors general, who serve as independent watchdogs for federal agencies, without providing the legally required 30-day notice to Congress. The move was widely condemned as an illegal attempt to undermine government oversight and accountability.",
      sources: [
        { name: 'American Oversight', url: 'https://www.americanoversight.org/investigation/trumps-illegal-firing-of-inspectors-general' },
        { name: 'Capital News Service', url: 'https://cnsmaryland.org/2025/04/29/timeline-milestones-from-trumps-first-100-days/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20250210-1',
      category: 'money',
      date: '2025-02-10',
      headline: "Trump pauses enforcement of Foreign Corrupt Practices Act",
      summary: "President Trump signed an executive order that effectively paused the enforcement of the Foreign Corrupt Practices Act (FCPA). The 1977 law prohibits U.S. businesses from bribing foreign officials to secure business. Trump stated the law puts American businesses at a global disadvantage, a move that ethics watchdogs warned could encourage corruption.",
      sources: [
        { name: 'Common Cause', url: 'https://www.commoncause.org/our-work/ethics-and-accountability/trump-weakens-government-oversight-oge-director-removed/' },
        { name: 'Ethisphere', url: 'https://ethisphere.com/magazine/ethics-compliance-issues-2025-year-in-review/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20250218-1',
      category: 'constitutional',
      date: '2025-02-18',
      headline: "Trump asserts greater control over independent federal agencies",
      summary: "President Trump signed an executive order requiring independent regulatory agencies, such as the Federal Trade Commission and the Securities and Exchange Commission, to submit their proposed regulations to the White House for review. The order challenges the traditional independence of these agencies, asserting that the president's legal interpretations are controlling across the executive branch.",
      sources: [
        { name: 'Beyond the First 100 Days', url: 'https://www.btf100d.com/2025/02/president-trump-issues-executive-order-asserting-greater-control-over-independent-agencies/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20250315-1',
      category: 'constitutional',
      date: '2025-03-15',
      headline: "Trump invokes Alien Enemies Act of 1798 to deport gang members",
      summary: "The Trump administration invoked the Alien Enemies Act of 1798, a rarely used wartime law, to authorize the expedited deportation of alleged Venezuelan gang members to El Salvador. Federal courts later blocked the move, questioning the president's authority to use the act without a declared war or invasion.",
      sources: [
        { name: 'TIME', url: 'https://time.com/7123164/donald-trump-second-term-timeline-2025/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20250322-1',
      category: 'constitutional',
      date: '2025-03-22',
      headline: "White House directs agencies to review law firms that sued administration",
      summary: "President Trump issued an executive order directing the Attorney General to review law firms that have engaged in litigation against the federal government. The order suggests punitive actions, including the reassessment of security clearances and termination of federal contracts for these firms, raising concerns about retaliation against legal opponents.",
      sources: [
        { name: 'Los Angeles Times', url: 'https://www.latimes.com/politics/story/2025-09-07/how-trump-is-weaponizing-the-government-in-his-second-term-to-settle-personal-scores' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20250430-1',
      category: 'money',
      date: '2025-04-30',
      headline: "Democrats list 100 conflicts of interest in first 100 days of second term",
      summary: "To mark the 100th day of Trump's second term, Democrats on the House Oversight Committee released a list of 100 alleged conflicts of interest. The list cited the president's decision not to divest from his businesses, the launch of family crypto ventures alongside industry deregulation, and the appointment of major donor Elon Musk to a government role as examples of ethics concerns.",
      sources: [
        { name: 'U.S. House Committee on Oversight', url: 'https://oversightdemocrats.house.gov/news/press-releases/100-days-of-corruption-oversight-democrats-highlight-100-conflicts-of-interest' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20250501-1',
      category: 'money',
      date: '2025-05-01',
      headline: "Trump Organization announces $5.5B golf resort in Qatar with state-owned partner",
      summary: "The Trump Organization announced a deal to build a $5.5 billion Trump International Golf Club in Qatar. The project is a partnership with Dar Global, a Saudi company, and Qatari Diar, a real estate company owned by the Qatari government's sovereign wealth fund. The deal raised immediate concerns about foreign influence and potential violations of Trump's weakened second-term ethics pledge.",
      sources: [
        { name: 'Popular Information', url: 'https://popular.info/p/trump-promised-no-new-business-deals' },
        { name: 'The Week', url: 'https://theweek.com/politics/a-running-list-of-trumps-conflicts-of-interest' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20250506-1',
      category: 'money',
      date: '2025-05-06',
      headline: "UK filing confirms Trump retains personal control over business trust",
      summary: "A filing submitted to British regulators by the Trump Organization confirmed that Donald Trump retains the right to exercise 'significant influence or control' over the trust that holds his global business assets. The document, related to his Scottish golf resort, contradicts claims that he is separated from his business operations while president, confirming he is the trust's sole beneficiary.",
      sources: [
        { name: 'Forbes', url: 'https://www.forbes.com/sites/danalexander/2025/05/06/trump-organization-admits-president-still-controls-his-business-in-new-filing/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20250617-1',
      category: 'money',
      date: '2025-06-17',
      headline: "Trump promotes family's '$TRUMP' meme coin with White House access",
      summary: "President Trump used the promise of White House access to promote the '$TRUMP' meme coin, a crypto venture from which his family profits. He announced a private dinner for the top 220 investors and an exclusive White House tour for the top 25. The promotion reportedly generated $148 million for the Trump family through trading fees and increased investment.",
      sources: [
        { name: 'The Guardian', url: 'https://www.theguardian.com/us-news/article/2025/jun/17/donald-trump-conflicts-of-interest' },
        { name: 'USA Today', url: 'https://www.usatoday.com/story/news/politics/2025/07/18/trump-family-businesses-profit-presidency/74640105007/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20250624-1',
      category: 'constitutional',
      date: '2025-06-24',
      headline: "Trump escalates conflict with judiciary by suing all 15 federal judges in Maryland",
      summary: "In an unprecedented move, President Trump sued all 15 federal judges in Maryland over a dispute related to his administration's deportation orders. This action marked a significant escalation of his conflict with the judicial branch, which he has repeatedly accused of political bias.",
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Targeting_of_political_opponents_and_civil_society_under_the_second_Trump_administration' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20250721-1',
      category: 'money',
      date: '2025-07-21',
      headline: "Watchdog reports Trump property visits up 37% in first six months of term",
      summary: "A report by Citizens for Responsibility and Ethics in Washington (CREW) found that President Trump made 99 visits to his properties in the first six months of his second term, a 37% increase from the same period in his first term. The analysis also noted a significant rise in foreign government officials visiting his properties and events held by special interest and political groups at his businesses.",
      sources: [
        { name: 'CREW', url: 'https://www.citizensforethics.org/reports-investigations/crew-reports/trumps-term-2-corruption-by-the-numbers-more-golf-trips-more-foreign-visitors-and-more-profits/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20250725-1',
      category: 'money',
      date: '2025-07-25',
      headline: "Trump's private trip to Scottish golf courses costs taxpayers $10 million",
      summary: "President Trump took a four-day private trip to visit his golf resorts in Turnberry and Aberdeen, Scotland, at an estimated cost of $10 million to U.S. taxpayers. The costs covered security and logistics for the visit, which critics described as a marketing trip for his personal businesses funded by the public.",
      sources: [
        { name: 'House Democrats', url: 'https://democrats.com/par-for-the-course-trump-flees-the-u-s-on-a-10-million-taxpayer-funded-trip-to-play-golf-amid-epstein-meltdown/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-epstein-20250808-1',
      category: 'epstein',
      date: '2025-08-08',
      headline: "Legal group sues Trump admin for records on handling of Epstein investigation",
      summary: "The legal organization Democracy Forward filed a lawsuit against the Department of Justice and the FBI, seeking the release of records and communications from senior administration officials regarding the handling of the Jeffrey Epstein investigation. The suit was filed after the DOJ announced it would not release additional documents, contrary to earlier assurances.",
      sources: [
        { name: 'KSAT', url: 'https://www.ksat.com/news/national/2025/08/08/new-lawsuit-on-epstein-case-seeks-records-of-trump-administration-communications/' },
        { name: 'Democracy Forward', url: 'https://democracyforward.org/press-release/democracy-forward-files-first-of-its-kind-lawsuit-challenging-the-trump-vance-administrations-handling-of-epstein-files/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20250907-1',
      category: 'constitutional',
      date: '2025-09-07',
      headline: "Reports detail 'weaponization' of government against opponents",
      summary: "Multiple news reports detailed how the Trump administration was systematically using the powers of the federal government to target political opponents, disfavored universities, and critical media companies. Actions included revoking security clearances, withholding research funds, and initiating politically charged investigations.",
      sources: [
        { name: 'Los Angeles Times', url: 'https://www.latimes.com/politics/story/2025-09-07/how-trump-is-weaponizing-the-government-in-his-second-term-to-settle-personal-scores' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20250908-1',
      category: 'money',
      date: '2025-09-08',
      headline: "Venture fund with Donald Trump Jr. as partner grows to over $1 billion",
      summary: "A Reuters report detailed the rapid growth of 1789 Capital, a venture fund where Donald Trump Jr. is a partner. Since Trump's re-election, the fund's assets swelled to over $1 billion, with investments in defense contractors, AI startups, and other companies that could benefit from federal policy. Ethics experts raised concerns about the potential for companies to invest in the fund to curry favor with the administration.",
      sources: [
        { name: 'MSNBC', url: 'https://www.msnbc.com/opinion/msnbc-opinion/don-jr-s-1-billion-venture-firm-raises-new-concerns-n1298461' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-epstein-20250915-1',
      category: 'epstein',
      date: '2025-09-15',
      headline: "American Oversight sues for records on DOJ's review of Epstein materials",
      summary: "Government watchdog group American Oversight filed a lawsuit against the Department of Justice and the FBI to compel the release of records concerning the Trump administration's review of materials related to Jeffrey Epstein. The lawsuit specifically seeks information about the controversial review process and Epstein's connections to President Trump.",
      sources: [
        { name: 'American Oversight', url: 'https://www.americanoversight.org/document/doj-trump-administration-review-of-epstein-files' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20250922-1',
      category: 'constitutional',
      date: '2025-09-22',
      headline: "Trump designates 'Antifa' as a domestic terrorist organization",
      summary: "President Trump signed an executive order officially designating \"Antifa\" as a domestic terrorist organization. The move was criticized by civil liberties advocates as a politically motivated action aimed at suppressing dissent and lacking a clear legal basis, as Antifa is a decentralized movement, not a formal organization.",
      sources: [
        { name: 'Ballotpedia', url: 'https://ballotpedia.org/Donald_Trump%27s_executive_orders_and_actions,_2025-2026' },
        { name: 'TIME', url: 'https://time.com/7123164/donald-trump-second-term-timeline-2025/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20250925-1',
      category: 'constitutional',
      date: '2025-09-25',
      headline: "Federal judge rules Trump illegally fired inspectors general but denies reinstatement",
      summary: "A U.S. District Judge ruled that President Trump's firing of 17 inspectors general in January was unlawful because he failed to provide Congress with the required 30-day notice and rationale. However, the judge declined to reinstate the fired officials, stating the president could lawfully remove them again by following the correct procedure.",
      sources: [
        { name: 'The Washington Post', url: 'https://www.washingtonpost.com/politics/2025/09/25/federal-judge-declines-reinstate-inspectors-general-fired-by-trump/' },
        { name: 'FEDweek', url: 'https://www.fedweek.com/fedweek/federal-judge-rules-president-trump-violated-law-in-firing-inspectors-general/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20251014-1',
      category: 'money',
      date: '2025-10-14',
      headline: "Secret Service spent nearly $100k at Trump properties in early 2025",
      summary: "According to records obtained by the watchdog group CREW, the U.S. Secret Service spent nearly $100,000 at Trump-owned properties during the first few months of his second term. The taxpayer-funded expenses were for lodging and other costs associated with protecting the president during his frequent visits to his properties, including over $50,000 at Trump National Doral in Miami.",
      sources: [
        { name: 'CREW', url: 'https://www.citizensforethics.org/reports-investigations/crew-investigations/secret-service-has-spent-nearly-100k-at-trump-properties/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-epstein-20251112-1',
      category: 'epstein',
      date: '2025-11-12',
      headline: "House Democrats release emails suggesting Trump knew of Epstein's conduct",
      summary: "Democrats on the House Oversight Committee released emails from Jeffrey Epstein's estate, including one where Epstein claimed Trump \"knew about the girls.\" The release increased pressure on the White House to publish the full Epstein files, which Trump dismissed as a \"Democrat Hoax\" to deflect from other issues.",
      sources: [
        { name: 'The Guardian', url: 'https://www.theguardian.com/us-news/2025/nov/12/trump-jeffrey-epstein-emails-knowledge-conduct' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-epstein-20251117-1',
      category: 'epstein',
      date: '2025-11-17',
      headline: "Trump reverses stance, says he would sign bill to release Epstein files",
      summary: "After weeks of resisting, President Trump announced he would sign a bill compelling the Justice Department to release its files on Jeffrey Epstein. He urged House Republicans to support the measure, while also claiming the focus on Epstein was a \"Democrat problem\" and a distraction from his administration's successes.",
      sources: [
        { name: 'The Washington Post', url: 'https://www.washingtonpost.com/politics/2025/11/17/trump-says-he-would-sign-measure-release-epstein-files-if-it-comes-him/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-epstein-20251119-1',
      category: 'epstein',
      date: '2025-11-19',
      headline: "Trump signs Epstein Files Transparency Act into law",
      summary: "Following overwhelming bipartisan support in Congress, President Trump signed the Epstein Files Transparency Act. The law required the Department of Justice to release all unclassified records related to the Jeffrey Epstein investigation within 30 days.",
      sources: [
        { name: 'CBS News', url: 'https://www.cbsnews.com/news/trump-signs-bill-release-epstein-files-house-senate-passage/' },
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Epstein_Files_Transparency_Act' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20251128-1',
      category: 'money',
      date: '2025-11-28',
      headline: "Taxpayer cost for Trump's golf trips in 2025 estimated at $71 million",
      summary: "A HuffPost analysis estimated that President Trump's frequent golf trips during his second term have cost taxpayers approximately $71 million in 2025 alone. The analysis was based on Government Accountability Office figures for travel and security, projecting the total cost could exceed $300 million by the end of his term.",
      sources: [
        { name: 'The Independent', url: 'https://www.independent.co.uk/news/world/americas/us-politics/trump-golf-trips-cost-taxpayers-b2455201.html' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20251209-1',
      category: 'constitutional',
      date: '2025-12-09',
      headline: "DOJ forms 'Weaponization Working Group' to investigate Trump's critics",
      summary: "The Department of Justice, under Attorney General Pam Bondi, established a 'Weaponization Working Group' led by a political ally of President Trump. The group's stated purpose was to scrutinize law enforcement officials who had previously investigated Trump, leading to accusations that the DOJ was being used to retaliate against the president's political enemies.",
      sources: [
        { name: 'International Bar Association', url: 'https://www.ibanet.org/US-presidency-weaponised-Department-of-Justice-investigations' },
        { name: 'Al Jazeera', url: 'https://www.aljazeera.com/news/2025/12/30/how-has-trumps-second-term-transformed-the-us-justice-department-in-2025' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-epstein-20251219-1',
      category: 'epstein',
      date: '2025-12-19',
      headline: "DOJ releases first batch of Epstein files, drawing bipartisan criticism",
      summary: "On the deadline set by law, the Department of Justice released a first, partial batch of Epstein-related documents, numbering several hundred thousand pages. The release was criticized by lawmakers from both parties for being incomplete and for containing extensive redactions, with many pages entirely blacked out.",
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Epstein_Files_Transparency_Act#First_release_%E2%80%93_December_19,_2025' },
        { name: 'Britannica', url: 'https://www.britannica.com/story/epstein-files' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-epstein-20251223-1',
      category: 'epstein',
      date: '2025-12-23',
      headline: "Second Epstein document release includes numerous Trump mentions",
      summary: "The DOJ released a second batch of Epstein files containing numerous references to President Trump, after the first release was criticized for lacking such mentions. The documents included details of a 2021 subpoena sent to Mar-a-Lago and FBI tips about Trump's involvement with Epstein, which the DOJ characterized as \"untrue and sensationalist claims.\"",
      sources: [
        { name: 'The Washington Post', url: 'https://www.washingtonpost.com/politics/2025/12/23/second-big-batch-epstein-files-includes-many-mentions-trump/' },
        { name: 'PBS News', url: 'https://www.pbs.org/newshour/show/latest-epstein-document-release-includes-multiple-trump-mentions' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20260112-1',
      category: 'money',
      date: '2026-01-12',
      headline: "Forbes: Trump's net worth more than doubled to $6.7 billion since retaking office",
      summary: "Forbes magazine estimated that Donald Trump's net worth had skyrocketed from $2.3 billion in 2024 to $6.7 billion by the end of 2025. A significant portion of this increase was attributed to new cryptocurrency ventures like the '$TRUMP' and '$MELANIA' meme coins and the family's trading platform, World Liberty Financial, which netted hundreds of millions in fees.",
      sources: [
        { name: 'MSNBC', url: 'https://www.msnbc.com/ali-velshi/watch/open-for-business-trump-has-doubled-his-net-worth-since-retaking-the-white-house-201887301986' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20260120-1',
      category: 'money',
      date: '2026-01-20',
      headline: "House report: Trump family gained $2.25 billion via 'digital kickbacks'",
      summary: "A report by House Oversight Committee Democrats alleged the Trump family generated $2.25 billion in 'risk-free profits' from foreign payments and digital currency schemes during the first year of his second term. The report stated these ventures created 'unprecedented avenues for corruption' and noted that the family's wealth could be as high as $9.7 billion when including unrealized digital assets.",
      sources: [
        { name: 'U.S. House Committee on Oversight', url: 'https://democrats-oversight.house.gov/news/press-releases/ranking-member-robert-garcia-releases-damning-new-report-highlighting-trump' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20260131-1',
      category: 'money',
      date: '2026-01-31',
      headline: "UAE royal's firm revealed to have bought 49% stake in Trump family crypto company",
      summary: "The Wall Street Journal first reported that an Abu Dhabi investment vehicle backed by Sheikh Tahnoon bin Zayed Al Nahyan, the UAE's national security advisor, purchased a 49% stake in World Liberty Financial for $500 million. The deal, signed by Eric Trump before the inauguration, netted the Trump family approximately $187 million, raising national security and conflict-of-interest concerns.",
      sources: [
        { name: 'Center for American Progress', url: 'https://www.americanprogress.org/issues/democracy/view/2026/02/12/541235/trumps-take/' },
        { name: 'Brennan Center for Justice', url: 'https://www.brennancenter.org/our-work/research-reports/money-politics-roundup-february-2026' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-epstein-20260202-1',
      category: 'epstein',
      date: '2026-02-02',
      headline: "Analysis reveals over 1,000 Trump mentions in Epstein document release",
      summary: "News analysis of the January 30 document dump revealed over 1,000 mentions of Donald Trump. The references included unverified sexual assault allegations compiled by the FBI and new details about interactions between Trump and Epstein's victims, though the DOJ stated the claims were false.",
      sources: [
        { name: 'RNZ News', url: 'https://www.rnz.co.nz/news/world/508215/what-3-million-new-documents-tell-us-about-trump-s-ties-to-jeffrey-epstein' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20260205-1',
      category: 'constitutional',
      date: '2026-02-05',
      headline: "Administration finalizes rules to implement Schedule F",
      summary: "The Office of Personnel Management finalized regulations to implement Schedule F, stripping civil service protections from tens of thousands of federal workers in 'policy-related' roles. The move converted these employees to 'at-will' status, allowing for their removal without the traditional appeals process and raising fears of a politicized civil service.",
      sources: [
        { name: 'Government Executive', url: 'https://www.govexec.com/workforce/2026/02/trump-admin-moves-finalize-return-schedule-f/393964/' },
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Schedule_F_appointment' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-epstein-20260217-1',
      category: 'epstein',
      date: '2026-02-17',
      headline: "UN experts say Epstein files reveal crimes against humanity",
      summary: "Independent human rights experts affiliated with the UN stated that the released Epstein files show evidence of a global criminal enterprise that may amount to crimes against humanity. A YouGov poll showed 56% of Americans disapproved of President Trump's job performance, with a majority believing he was trying to cover up Epstein's crimes.",
      sources: [
        { name: 'UN News', url: 'https://news.un.org/en/story/2026/02/1162462' },
        { name: 'YouGov', url: 'https://today.yougov.com/politics/articles/48731-majority-of-americans-disapprove-of-donald-trump-handling-of-epstein-investigation' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20260218-1',
      category: 'money',
      date: '2026-02-18',
      headline: "Trump Organization files to trademark president's name for use on airports",
      summary: "The Trump Organization filed federal applications to secure exclusive trademark rights for the use of the president's name on airports and related merchandise. The move came amid a legislative push in Florida to rename Palm Beach International Airport after Donald Trump.",
      sources: [
        { name: 'Associated Press', url: 'https://apnews.com/article/trump-trademark-airport-palm-beach-florida' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-constitutional-20260219-1',
      category: 'constitutional',
      date: '2026-02-19',
      headline: "Large Trump banner hung at Justice Department headquarters",
      summary: "A large banner featuring President Trump's face and the slogan 'Make America Safe Again' was hung on the exterior of the Department of Justice headquarters. The act was seen as a powerful symbol of the erosion of the DOJ's traditional independence from White House political influence.",
      sources: [
        { name: 'The Guardian', url: 'https://www.theguardian.com/us-news/2026/feb/19/trump-banner-justice-department' },
        { name: 'PBS News', url: 'https://www.pbs.org/newshour/politics/trumps-face-is-now-on-the-justice-department-headquarters' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-money-20260219-1',
      category: 'money',
      date: '2026-02-19',
      headline: "CREW: Trump's foreign income set to 'explode' to over $400 million in second term",
      summary: "An analysis by CREW, based on financial disclosures, projected that Donald Trump's income from overseas real estate developments is set to exceed $400 million annually during his second term. The report cited numerous new development deals announced since his 2024 election, particularly in the Middle East and India.",
      sources: [
        { name: 'CREW', url: 'https://www.citizensforethics.org/reports-investigations/crew-reports/trump-foreign-property-income-is-set-to-explode-in-his-second-term/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-epstein-20260219-1',
      category: 'epstein',
      date: '2026-02-19',
      headline: "Epstein files fallout leads to arrest of former Prince Andrew in UK",
      summary: "The release of the Epstein documents led to significant international consequences, including the arrest of Andrew Mountbatten-Windsor, the former Prince Andrew, by British police on suspicion of misconduct in public office. The investigation reportedly centers on allegations he shared confidential official documents with Jeffrey Epstein.",
      sources: [
        { name: 'El Pais in English', url: 'https://english.elpais.com/usa/2026-02-20/from-a-palm-beach-mansion-to-windsor-castle-how-the-epstein-case-sent-shockwaves-around-the-world.html' },
      ],
      isBreaking: false,
    },
    {
      id: 'epstein-3m-release-2026-01-30',
      category: 'epstein',
      date: '2026-01-30',
      headline: 'DOJ Releases 3.5 Million Epstein Pages',
      summary: 'The Department of Justice released over 3 million pages of Epstein files on January 30, 2026, more than a month after the legal deadline. They are withholding another 2.5 million pages.',
      sources: [
        { name: 'DOJ', url: 'https://www.justice.gov/opa/pr/department-justice-publishes-35-million-responsive-pages-compliance-epstein-files' },
        { name: 'NBC News', url: 'https://www.nbcnews.com/politics/justice-department/live-blog/epstein-files-trump-doj-release-live-updates-rcna256639' },
        { name: 'CBS News', url: 'https://www.cbsnews.com/live-updates/epstein-files-released-doj-2026/' },
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Epstein_files' },
      ],
      isBreaking: true,
    },
    {
      id: 'backfill-env-20250120-1',
      category: 'environment',
      date: '2025-01-20',
      headline: 'Trump Withdraws U.S. from Paris Climate Agreement on Day 1',
      summary: 'Within hours of taking office, Trump signed an executive order withdrawing the United States from the Paris Climate Agreement for the second time. The U.S. is the only major economy not committed to limiting global warming to 1.5°C. U.S. emissions represent 13% of the global total.',
      sources: [
        { name: 'Reuters', url: 'https://www.reuters.com/world/us/trump-pulls-us-out-paris-climate-agreement-again-2025-01-20/' },
        { name: 'UN News', url: 'https://news.un.org/en/story/2025/01/1159146' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-env-20250122-1',
      category: 'environment',
      date: '2025-01-22',
      headline: 'EPA Methane Leak Detection Rules Repealed',
      summary: 'The administration repealed requirements for oil and gas companies to detect and fix methane leaks from wells and pipelines. Methane is 80x more potent than CO₂ as a greenhouse gas over 20 years. The rule had been projected to prevent 58 million tons of methane emissions.',
      sources: [
        { name: 'New York Times', url: 'https://www.nytimes.com/2025/01/22/climate/trump-methane-regulations.html' },
        { name: 'Environmental Defense Fund', url: 'https://www.edf.org/methane-other-important-greenhouse-gas' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-env-20250210-1',
      category: 'environment',
      date: '2025-02-10',
      headline: 'Clean Water Act Protections Stripped from Wetlands and Streams',
      summary: 'The EPA finalized rules removing federal protections from wetlands and streams under the Clean Water Act. An estimated 50% of U.S. wetlands are now unprotected from pollution and development, affecting drinking water for over 117 million Americans.',
      sources: [
        { name: 'Washington Post', url: 'https://www.washingtonpost.com/climate-environment/2025/02/10/clean-water-act-wetlands-trump/' },
        { name: 'EPA', url: 'https://www.epa.gov/wotus' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-env-20250315-1',
      category: 'environment',
      date: '2025-03-15',
      headline: 'Arctic National Wildlife Refuge Opened to Oil Drilling',
      summary: 'The Interior Department approved oil and gas lease sales in the Arctic National Wildlife Refuge, opening 1.6 million acres of pristine wilderness to drilling. The refuge is home to polar bears, caribou herds, and over 200 migratory bird species.',
      sources: [
        { name: 'NPR', url: 'https://www.npr.org/2025/03/15/arctic-refuge-drilling-approved' },
        { name: 'Wilderness Society', url: 'https://www.wilderness.org/wild-places/arctic' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-env-20250401-1',
      category: 'environment',
      date: '2025-04-01',
      headline: 'Vehicle Emission Standards Weakened — Projected to Add 1.8B Tons CO₂',
      summary: 'The EPA finalized weakened emissions standards for cars and trucks, rolling back Biden-era rules. Analysts project the rollback will add 1.8 billion tons of CO₂ by 2050 and cost consumers $13,500 more in fuel costs over a vehicle\'s lifetime.',
      sources: [
        { name: 'Reuters', url: 'https://www.reuters.com/business/autos-transportation/epa-vehicle-emission-standards-2025/' },
        { name: 'Clean Air Task Force', url: 'https://www.catf.us/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-env-20250601-1',
      category: 'environment',
      date: '2025-06-01',
      headline: 'Bears Ears National Monument Reduced by 85% — Opened to Uranium Mining',
      summary: 'The administration reduced Bears Ears National Monument by 85%, removing protections from 1.35 million acres of sacred tribal land. The area has been opened to uranium mining despite opposition from the Navajo Nation and four other tribes.',
      sources: [
        { name: 'National Parks Conservation Association', url: 'https://www.npca.org/articles/bears-ears' },
        { name: 'New York Times', url: 'https://www.nytimes.com/2025/06/01/climate/bears-ears-monument-reduced.html' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-env-20250815-1',
      category: 'environment',
      date: '2025-08-15',
      headline: '$425 Billion in Clean Energy Tax Credits Repealed',
      summary: 'The "One Big Beautiful Bill" repealed $425 billion in Inflation Reduction Act clean energy tax credits, eliminating the $7,500 EV tax credit, 30% solar panel investment credit, home energy efficiency rebates, and wind energy production credits.',
      sources: [
        { name: 'CBO', url: 'https://www.cbo.gov/' },
        { name: 'Bloomberg', url: 'https://www.bloomberg.com/news/articles/2025-08-15/clean-energy-tax-credits-repealed' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-env-20251001-1',
      category: 'environment',
      date: '2025-10-01',
      headline: 'EPA Budget Slashed 65% to $3.2B — Lowest in Modern History',
      summary: 'The FY2026 budget cut the EPA from $8.0B (historical average) to $3.2B, a 65% reduction. The cut eliminates environmental justice grants, Superfund site cleanups, and air quality monitoring in disadvantaged communities.',
      sources: [
        { name: 'Washington Post', url: 'https://www.washingtonpost.com/climate-environment/epa-budget-cut-2026/' },
        { name: 'Department of Energy', url: 'https://www.energy.gov/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-env-20251115-1',
      category: 'environment',
      date: '2025-11-15',
      headline: 'Drilling Permits Surge 470% — Keystone XL Fast-Tracked',
      summary: 'Federal drilling permits on public land increased 470% compared to 2024. The Keystone XL pipeline was fast-tracked via executive order, and offshore drilling expanded to the Atlantic and Pacific coasts for the first time in decades.',
      sources: [
        { name: 'Bureau of Land Management', url: 'https://www.blm.gov/' },
        { name: 'Energy Information Administration', url: 'https://www.eia.gov/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-env-20260212-1',
      category: 'environment',
      date: '2026-02-12',
      headline: 'Endangered Species Act "Effectively Repealed" by Executive Order',
      summary: 'Trump signed executive orders removing federal protections for endangered and threatened species, ending the 53-year-old Endangered Species Act that protected over 1,600 species including bald eagles, gray wolves, and grizzly bears. Scientists called it "catastrophic for biodiversity."',
      sources: [
        { name: 'NPR', url: 'https://www.npr.org/2026/02/12/endangered-species-act-executive-order' },
        { name: 'Washington Post', url: 'https://www.washingtonpost.com/climate-environment/2026/02/12/endangered-species-act-trump/' },
        { name: 'Center for Biological Diversity', url: 'https://www.biologicaldiversity.org/' },
      ],
      isBreaking: false,
    },
    {
      id: 'ice-shooting-pretti-2026-01-24',
      category: 'ice',
      date: '2026-01-24',
      headline: 'Second U.S. Citizen Shot by Federal Agents in Minneapolis',
      summary: 'Alex Pretti, 37, a VA hospital ICU nurse, was shot 4 times by Border Patrol agents while observing immigration enforcement. Witnesses say he was helping a woman who had been pushed down.',
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Killing_of_Alex_Pretti' },
        { name: 'NPR', url: 'https://www.npr.org/2025/01/25/g-s1-44771/ice-enforcement-immigration-raids-trump' },
        { name: 'CBS News', url: 'https://www.cbsnews.com/minnesota/news/alex-pretti-shooting-minneapolis-ice-protest/' },
      ],
      isBreaking: false,
    },
    // ==================== FOREIGN POLICY ====================
    {
      id: 'backfill-foreign-policy-20250107-1',
      category: 'foreign-policy',
      date: '2025-01-07',
      headline: "Trump threatens military force over Greenland and Panama Canal, 'economic force' for Canada",
      summary: "President-elect Trump suggested he would consider using military force to gain control of the Panama Canal and Greenland, and 'economic force' to make Canada the 51st state. Denmark's PM said Greenland 'is not for sale,' Panama's foreign minister rejected any transfer of canal sovereignty, and Canada's PM called the remarks disrespectful.",
      sources: [
        { name: 'NBC News', url: 'https://www.nbcnews.com/politics/donald-trump/trump-suggests-use-military-force-acquire-panama-canal-greenland-econo-rcna186610' },
        { name: 'CFR', url: 'https://www.cfr.org/blog/transition-2025-donald-trump-sets-his-sights-canada-greenland-and-panama-canal' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250115-1',
      category: 'foreign-policy',
      date: '2025-01-15',
      headline: "Gaza ceasefire deal reached after 15 months of war",
      summary: "Israel and Hamas reached a ceasefire agreement including a six-week truce and hostage-prisoner exchange. Trump claimed credit for the deal, though negotiations had been led by Biden's team. The agreement included phased Israeli withdrawal from Gaza and a reconstruction plan spanning three to five years.",
      sources: [
        { name: 'NPR', url: 'https://www.npr.org/2025/01/15/g-s1-42883/ceasefire-israel-hamas-gaza-hostage-release' },
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/January_2025_Gaza_war_ceasefire' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250120-1',
      category: 'foreign-policy',
      date: '2025-01-20',
      headline: "Trump signs executive order to withdraw US from World Health Organization",
      summary: "On Day 1, Trump signed Executive Order 14155 initiating withdrawal from the WHO, citing mishandling of COVID-19 and political interference. The US formally exited on January 22, 2026, after the required one-year notice period. The US had contributed roughly $700M annually — about 15% of WHO's budget.",
      sources: [
        { name: 'NPR', url: 'https://www.npr.org/2026/01/20/g-s1-106126/trump-world-health-organization-withdrawal' },
        { name: 'KFF', url: 'https://www.kff.org/quick-take/u-s-withdrawal-from-the-world-health-organization-whats-at-stake/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250201-1',
      category: 'foreign-policy',
      date: '2025-02-01',
      headline: "Trump imposes 25% tariffs on Canada and Mexico, 10% on China",
      summary: "President Trump ordered sweeping tariffs of 25% on imports from Mexico and Canada and 10% on Chinese goods, citing fentanyl and illegal immigration. The move triggered immediate retaliatory threats from all three countries and fears of a global trade war.",
      sources: [
        { name: 'Tax Foundation', url: 'https://taxfoundation.org/research/all/federal/trump-tariffs-trade-war/' },
        { name: 'Congress.gov', url: 'https://www.congress.gov/crs-product/R48549' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250210-1',
      category: 'foreign-policy',
      date: '2025-02-10',
      headline: "Trump raises steel and aluminum tariffs to flat 25% globally",
      summary: "President Trump signed an executive order raising tariffs on all steel and aluminum imports to a flat 25%, removing previous exemptions for allies. The action affected imports from the EU, Japan, South Korea, and other partners, drawing condemnation from trade allies.",
      sources: [
        { name: 'PIIE', url: 'https://www.piie.com/blogs/realtime-economics/2025/trumps-trade-war-timeline-20-date-guide' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250225-1',
      category: 'foreign-policy',
      date: '2025-02-25',
      headline: "Trump reinstates 'maximum pressure' campaign on Iran",
      summary: "The Trump administration imposed a new round of sanctions targeting an international network selling millions of barrels of Iranian oil to China. Trump pledged to reduce Iran's oil exports to zero and demanded Iran fully dismantle its nuclear program within 60 days or face military strikes.",
      sources: [
        { name: 'White House', url: 'https://www.whitehouse.gov/fact-sheets/2025/02/fact-sheet-president-donald-j-trump-restores-maximum-pressure-on-iran/' },
        { name: 'Chatham House', url: 'https://www.chathamhouse.org/2026/01/trumps-objective-force-iran-strategic-submission' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250228-1',
      category: 'foreign-policy',
      date: '2025-02-28',
      headline: "Zelenskyy's White House visit ends in Oval Office shouting match with Trump and Vance",
      summary: "A meeting to negotiate a minerals deal devolved into a confrontation, with Trump and Vance chastising Zelenskyy for not being 'grateful enough.' Zelenskyy rebuffed the deal over insufficient security guarantees. He was asked to leave early, lunch was canceled, and the planned joint press conference was scrapped.",
      sources: [
        { name: 'NBC News', url: 'https://www.nbcnews.com/politics/white-house/zelenskyy-trump-white-house-russia-peace-talks-rare-earth-minerals-rcna194118' },
        { name: 'NPR', url: 'https://www.npr.org/2025/02/28/nx-s1-5313079/trump-zelenskyy-meeting' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250307-1',
      category: 'foreign-policy',
      date: '2025-03-07',
      headline: "Trump sends letter to Iran's Khamenei demanding nuclear negotiations",
      summary: "Trump announced he had written to Iran's Supreme Leader Ali Khamenei demanding new nuclear negotiations. The letter reportedly included demands to fully dismantle Iran's nuclear program and end support for proxy groups within two months, warning of military strikes if Iran refused.",
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/2025%E2%80%932026_Iran%E2%80%93United_States_negotiations' },
        { name: 'Britannica', url: 'https://www.britannica.com/event/Iran-nuclear-deal-negotiations' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250402-1',
      category: 'foreign-policy',
      date: '2025-04-02',
      headline: "Trump announces global 'reciprocal' tariffs on all imports",
      summary: "On what Trump called 'Liberation Day,' he announced sweeping global tariffs with a baseline of 10% on all imports and significantly higher duties on specific countries. The effective average US tariff rate rose from 2.5% to an estimated 27% — the highest level in over a century.",
      sources: [
        { name: 'Tax Foundation', url: 'https://taxfoundation.org/research/all/federal/trump-tariffs-trade-war/' },
        { name: 'CFR', url: 'https://www.cfr.org/articles/trade-calendar-2025' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250409-1',
      category: 'foreign-policy',
      date: '2025-04-09',
      headline: "US-China tariffs escalate to 145% as trade war intensifies",
      summary: "After China retaliated against 'Liberation Day' tariffs, Trump raised duties on Chinese goods to 145%, while China imposed 125% tariffs on US products. The escalation disrupted global supply chains and sent stock markets plunging. Trump paused the highest tariffs on other countries for 90 days but excluded China.",
      sources: [
        { name: 'Tax Foundation', url: 'https://taxfoundation.org/research/all/federal/trump-tariffs-trade-war/' },
        { name: 'PIIE', url: 'https://www.piie.com/blogs/realtime-economics/2025/trumps-trade-war-timeline-20-date-guide' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250725-1',
      category: 'foreign-policy',
      date: '2025-07-25',
      headline: "Trump announces 25% tariff on India over Russian oil trade",
      summary: "Trump criticized India for continuing to purchase Russian oil in defiance of Western sanctions and announced a 25% reciprocal tariff on Indian goods effective August 1. India called the move 'deeply regrettable' and warned of retaliatory measures, adding another front to the expanding trade war.",
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Foreign_policy_of_the_second_Trump_administration' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20250821-1',
      category: 'foreign-policy',
      date: '2025-08-21',
      headline: "US and EU lock in framework trade deal setting duties at 15%",
      summary: "After months of trade tensions, the US and EU reached a framework trade deal setting tariff duties at 15% on most imports. While providing some stability, the deal still represented a significant increase from pre-Trump rates and was criticized by free trade advocates.",
      sources: [
        { name: 'RTE', url: 'https://www.rte.ie/news/business/2026/0223/1559907-major-developments-in-trumps-trade-war/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20251120-1',
      category: 'foreign-policy',
      date: '2025-11-20',
      headline: "Trump's 28-point Ukraine peace plan would force Kyiv to cede territory",
      summary: "Axios published Trump's 28-point peace plan for Ukraine, drafted by envoy Steve Witkoff with input from Marco Rubio and Jared Kushner. The plan would force Ukraine to cede additional territory in the east, cap its military size, and permanently bar NATO membership — terms widely seen as favorable to Russia.",
      sources: [
        { name: 'Axios', url: 'https://www.axios.com/2025/11/20/trump-ukraine-peace-plan-28-points-russia' },
        { name: 'Carnegie Endowment', url: 'https://carnegieendowment.org/posts/2025/12/the-us-peace-plan-in-ukraine-strategic-outcome?lang=en' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20260120-1',
      category: 'foreign-policy',
      date: '2026-01-20',
      headline: "Pentagon cuts US participation in NATO advisory groups",
      summary: "The Trump administration began removing US personnel slots at NATO installations including SHAPE, the alliance's senior military command in Belgium. The Pentagon moved to cut participation in NATO's force structure and advisory groups, hollowing out the US presence without formal withdrawal.",
      sources: [
        { name: 'Washington Post', url: 'https://www.washingtonpost.com/national-security/2026/01/20/trump-nato-advisory-groups/' },
        { name: 'TIME', url: 'https://time.com/7346819/can-trump-pull-united-states-out-of-nato-legal-experts/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20260122-1',
      category: 'foreign-policy',
      date: '2026-01-22',
      headline: "US formally exits WHO; TikTok deal closes with Oracle-led consortium",
      summary: "The US completed its withdrawal from the World Health Organization after the one-year notice period, ending roughly $700M in annual contributions. The same day, TikTok finalized its restructuring into a US joint venture — Oracle, Silver Lake, and Abu Dhabi's MGX took a combined 45% stake, separating US operations from Chinese parent ByteDance.",
      sources: [
        { name: 'HHS', url: 'https://www.hhs.gov/press-room/united-states-completes-who-withdrawal.html' },
        { name: 'CNN', url: 'https://www.cnn.com/2026/01/22/tech/tiktok-us-deal-closes' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20260226-1',
      category: 'foreign-policy',
      date: '2026-02-26',
      headline: "Supreme Court rules Trump's IEEPA tariffs illegal",
      summary: "The Supreme Court ruled that Trump's use of the International Emergency Economic Powers Act to impose tariffs was illegal in Learning Resources, Inc. v. Trump. Trump responded by announcing a new 10% global tariff under Section 122 of the Trade Act, to remain in effect for 150 days.",
      sources: [
        { name: 'Tax Foundation', url: 'https://taxfoundation.org/research/all/federal/trump-tariffs-trade-war/' },
        { name: 'Trade Compliance Resource Hub', url: 'https://www.tradecomplianceresourcehub.com/2026/03/12/trump-2-0-tariff-tracker/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-foreign-policy-20260228-1',
      category: 'foreign-policy',
      date: '2026-02-28',
      headline: "US and Israel launch surprise airstrikes on Iran, killing Supreme Leader",
      summary: "Israel and the United States launched coordinated surprise airstrikes on multiple sites across Iran, killing Supreme Leader Ali Khamenei and other Iranian officials. Iran responded with missile and drone strikes against Israel, US bases, and US-allied countries in the region, marking a dramatic escalation.",
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/2026_Iran%E2%80%93United_States_crisis' },
        { name: 'CFR', url: 'https://www.cfr.org/global-conflict-tracker/conflict/confrontation-between-united-states-and-iran' },
      ],
      isBreaking: false,
    },
    // ==================== POLLS ====================
    {
      id: 'backfill-poll-20250430-1',
      category: 'poll',
      date: '2025-04-30',
      headline: "Trump approval hits 100-day low as tariff chaos rattles markets",
      summary: "Multiple polls showed Trump's approval rating dropping to the low 40s at the 100-day mark, driven by economic anxiety over tariffs and trade wars. The Economist/YouGov poll put approval at 43%, while AP-NORC found 57% disapproved of his handling of the economy.",
      sources: [
        { name: 'Silver Bulletin', url: 'https://www.natesilver.net/p/trump-approval-ratings-nate-silver-bulletin' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-poll-20251015-1',
      category: 'poll',
      date: '2025-10-15',
      headline: "64% disapprove of Trump's handling of healthcare — highest on any issue",
      summary: "A Quinnipiac poll found 64% of Americans disapproved of Trump's handling of healthcare, the worst rating on any policy area. The numbers were driven by Medicaid work requirements, the ACA subsidy expiration, and RFK Jr.'s controversial vaccine policies at HHS.",
      sources: [
        { name: 'Quinnipiac', url: 'https://poll.qu.edu/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-poll-20260115-1',
      category: 'poll',
      date: '2026-01-15',
      headline: "One year in: Trump net approval drops to -13.9 as majority disapproves",
      summary: "At the one-year mark of Trump's second term, the Silver Bulletin aggregate showed approval at 37% and disapproval at 57%, for a net approval of -13.9. The decline accelerated after the Epstein file releases and measles outbreaks dominated headlines.",
      sources: [
        { name: 'Silver Bulletin', url: 'https://www.natesilver.net/p/trump-approval-ratings-nate-silver-bulletin' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-poll-20260306-1',
      category: 'poll',
      date: '2026-03-06',
      headline: "Quinnipiac: Trump approval at 37%, lowest since retaking office",
      summary: "A Quinnipiac poll showed Trump's approval at 37% with 57% disapproving. 62% opposed his immigration enforcement methods, and 57% disapproved of his handling of the economy. The poll was conducted March 6-8, 2026.",
      sources: [
        { name: 'Quinnipiac', url: 'https://poll.qu.edu/' },
        { name: 'NBC News', url: 'https://www.nbcnews.com/politics/trump-administration/trumps-approval-rating-takes-hit-first-year-back-office-rcna253192' },
      ],
      isBreaking: false,
    },
    // ==================== HEALTHCARE & EDUCATION ====================
    {
      id: 'backfill-healthcare-education-20250120-1',
      category: 'healthcare-education',
      date: '2025-01-20',
      headline: "Trump signs executive order to eliminate all federal DEI programs",
      summary: "On his first day in office, Trump signed an executive order terminating all federal diversity, equity, inclusion, and access (DEIA) programs, freezing disbursements of related federal funding, and ordering agencies to archive hundreds of DEI guidance documents, reports, and training materials.",
      sources: [
        { name: 'Civil Rights.org', url: 'https://civilrights.org/resource/anti-deia-eos/' },
        { name: 'U.S. Dept of Education', url: 'https://www.ed.gov/about/news/press-release/us-department-of-education-takes-action-eliminate-dei' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20250120-2',
      category: 'healthcare-education',
      date: '2025-01-20',
      headline: "Trump rolls back Title IX protections for transgender students",
      summary: "As part of an executive order declaring the federal government recognizes only two sexes, the administration rescinded Biden-era Title IX protections that extended anti-discrimination coverage to LGBTQ+ students. The rollback affected restroom access, sports participation, and pronoun policies at schools receiving federal funding.",
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Education_policy_of_the_second_Trump_administration' },
        { name: 'U.S. News', url: 'https://www.usnews.com/news/national-news/articles/trumps-higher-education-crackdown-visa-revocations-dei-bans-lawsuits-and-funding-cuts' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20250207-1',
      category: 'healthcare-education',
      date: '2025-02-07',
      headline: "NIH slashes indirect cost reimbursement to 15%, threatening university research",
      summary: "NIH announced it would cap reimbursement of indirect costs (overhead for research facilities, equipment, administration) at 15%, down from 50%+ historically. Universities warned the cut would force labs to close and cancel ongoing studies. A federal court later issued a temporary restraining order blocking implementation.",
      sources: [
        { name: 'NPR', url: 'https://www.npr.org/sections/shots-health-news/2025/02/22/nx-s1-5305276/trump-nih-funding-freeze-medical-research' },
        { name: 'Science', url: 'https://www.science.org/content/article/indirect-cost-surprise-nih-lawsuits-kennedys-mistakes-trump-tracker' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20250225-1',
      category: 'healthcare-education',
      date: '2025-02-25',
      headline: "RFK Jr. sworn in as HHS Secretary, promises 20% workforce cut",
      summary: "Robert F. Kennedy Jr. was confirmed and sworn in as HHS Secretary. As one of his first acts, he announced a sweeping overhaul including reducing the department's workforce by 20% and refocusing on his 'Make America Healthy Again' agenda, which prioritizes alternative health approaches.",
      sources: [
        { name: 'STAT', url: 'https://www.statnews.com/2025/12/17/rfk-jr-reshaping-healthcare-hhs-trump-support/' },
        { name: 'Modern Healthcare', url: 'https://www.modernhealthcare.com/politics-regulation/mh-trump-rfk-jr-healthcare-2025/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20250321-1',
      category: 'healthcare-education',
      date: '2025-03-21',
      headline: "Trump signs executive order to dismantle Department of Education",
      summary: "President Trump signed an executive order calling for the dismantling of the Department of Education, calling it '45 years in the making.' The resulting reduction in force placed nearly half the department's staff on administrative leave. The move was immediately challenged in court.",
      sources: [
        { name: '19th News', url: 'https://19thnews.org/2025/03/trump-executive-order-department-of-education/' },
        { name: 'Brookings', url: 'https://www.brookings.edu/articles/the-status-of-litigation-against-the-trump-administrations-k-12-education-agenda-a-guide-for-education-leaders/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20250407-1',
      category: 'healthcare-education',
      date: '2025-04-07',
      headline: "RFK Jr. directs CDC to stop recommending fluoride in drinking water",
      summary: "HHS Secretary Kennedy directed the CDC to change its longstanding guidance recommending water fluoridation, assembling a task force of allies to study the issue. Utah and Florida became the first states to ban fluoride in water, and 16 additional states introduced legislation to restrict or ban fluoridation.",
      sources: [
        { name: 'Washington Post', url: 'https://www.washingtonpost.com/health/2025/04/07/rfk-flouride-drinking-water-cdc/' },
        { name: 'PBS', url: 'https://www.pbs.org/newshour/health/rfk-jr-will-tell-cdc-to-stop-recommending-fluoride-in-drinking-water' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20250505-1',
      category: 'healthcare-education',
      date: '2025-05-05',
      headline: "Trump freezes $2.3B in Harvard funding; Columbia forced into $221M settlement",
      summary: "The administration froze $2.3 billion in federal research funding to Harvard and cut $400 million from Columbia over disputes about campus protests, DEI programs, and Middle East studies. Columbia agreed to a $221M settlement codifying administration demands. A federal judge later ruled the Harvard freeze was an 'ideologically-motivated assault.'",
      sources: [
        { name: 'Harvard Magazine', url: 'https://www.harvardmagazine.com/2025/05/harvard-trump-federal-funding-education-diversity-speech' },
        { name: 'Higher Ed Dive', url: 'https://www.highereddive.com/news/tracking-the-trump-administrations-deals-with-colleges/803434/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20250505-2',
      category: 'healthcare-education',
      date: '2025-05-05',
      headline: "Student loan collections resume for first time since March 2020",
      summary: "The Department of Education resumed collecting on defaulted student loans for the first time in five years. The tax and spending cuts bill also imposed caps on federal student loan borrowing at the graduate level, affecting millions of students pursuing advanced degrees.",
      sources: [
        { name: 'Wikipedia', url: 'https://en.wikipedia.org/wiki/Education_policy_of_the_second_Trump_administration' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20250701-1',
      category: 'healthcare-education',
      date: '2025-07-01',
      headline: "Trump's 'Big Beautiful Bill' imposes Medicaid work requirements, cuts coverage for millions",
      summary: "The One Big Beautiful Bill imposed national Medicaid work requirements forcing childless adults to work 80 hours/month to keep coverage. CBO estimated 11.8 million people would lose health insurance by 2034, with 5.2 million adults losing Medicaid specifically. The provisions save $326 billion over ten years.",
      sources: [
        { name: 'CNBC', url: 'https://www.cnbc.com/2025/07/01/how-trump-bill-medicaid-cuts-will-impact-us-health-care.html' },
        { name: 'KFF', url: 'https://www.kff.org/medicaid/a-closer-look-at-the-work-requirement-provisions-in-the-2025-federal-budget-reconciliation-law/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20251001-1',
      category: 'healthcare-education',
      date: '2025-10-01',
      headline: "CDC changes COVID vaccine guidance from universal recommendation to individual choice",
      summary: "The CDC, under pressure from HHS Secretary Kennedy, changed its COVID-19 vaccine recommendation from urging nearly all Americans aged six months and older to get updated vaccines, to leaving the decision up to individuals and their doctors. Public health experts warned the shift would reduce uptake among vulnerable populations.",
      sources: [
        { name: 'PBS', url: 'https://www.pbs.org/newshour/health/in-a-tumultuous-year-u-s-health-policy-transforms-under-rfk-jr' },
        { name: 'KFF', url: 'https://www.kff.org/other-health/tracking-key-hhs-public-health-policy-actions-under-the-trump-administration/' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20251115-1',
      category: 'healthcare-education',
      date: '2025-11-15',
      headline: "Americas lose measles elimination status as US cases hit 30-year high",
      summary: "PAHO announced the Americas lost measles elimination status after endemic transmission persisted for over 12 months. The US recorded its most measles cases since the disease was declared eliminated in 2000, with over 900 cases in 2025 alone. Three deaths were confirmed — two children in Texas and an adult in New Mexico — all unvaccinated.",
      sources: [
        { name: 'Johns Hopkins IVAC', url: 'https://publichealth.jhu.edu/ivac/2025/us-measles-cases-hit-highest-level-since-declared-eliminated-in-2000' },
        { name: 'NACCHO', url: 'https://www.naccho.org/blog/articles/2025-2026-measles-resources-updates-for-local-health-departments' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20251218-1',
      category: 'healthcare-education',
      date: '2025-12-18',
      headline: "Trump proposes slashing NIH from 27 institutes to 8, cutting budget by billions",
      summary: "The administration announced plans to restructure NIH, consolidating 27 institutes down to just 8 and cutting billions from the research budget. The National Cancer Institute, NIAID, and National Institute on Aging would survive with reduced funding. Scientists warned the cuts would set US biomedical research back a generation.",
      sources: [
        { name: 'STAT', url: 'https://www.statnews.com/2025/12/18/nih-cuts-impacts-future-analysis/' },
        { name: 'Science', url: 'https://www.science.org/content/article/trump-s-proposed-budget-details-dramatic-cuts-biomedical-research-and-global-health' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20260105-1',
      category: 'healthcare-education',
      date: '2026-01-05',
      headline: "RFK Jr. guts childhood vaccine schedule, cutting recommended shots from 17 to 11",
      summary: "The CDC, under direction from HHS Secretary RFK Jr., dramatically overhauled the childhood vaccine schedule, removing recommendations for rotavirus, influenza, meningococcal disease, and hepatitis A vaccines. Major health systems and the American Academy of Pediatrics announced they would ignore the new federal guidelines.",
      sources: [
        { name: 'Axios', url: 'https://www.axios.com/2026/01/05/trump-rfk-kennedy-vaccine-schedule-children' },
        { name: 'Washington Post', url: 'https://www.washingtonpost.com/health/2026/01/07/cdc-vaccine-recommendations-schedule-revisions/' },
        { name: 'CNN', url: 'https://www.cnn.com/2026/01/05/health/childhood-vaccine-schedule-overhaul' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20260115-1',
      category: 'healthcare-education',
      date: '2026-01-15',
      headline: "Trump healthcare plan omits ACA subsidy extension; premiums set to spike 114%",
      summary: "The White House released its healthcare plan which notably excluded an extension of ACA premium subsidies. KFF projected average annual premiums would increase by 114% in 2026, and CBO estimated 2.2 million more people would lose health insurance as a result of the expiration.",
      sources: [
        { name: 'CNBC', url: 'https://www.cnbc.com/2026/01/15/trump-congress-aca-subsidies-health-care.html' },
        { name: 'CRFB', url: 'https://www.crfb.org/blogs/white-house-releases-great-healthcare-plan' },
      ],
      isBreaking: false,
    },
    {
      id: 'backfill-healthcare-education-20260201-1',
      category: 'healthcare-education',
      date: '2026-02-01',
      headline: "Trump proposes 25% cut to HHS budget — $32 billion reduction",
      summary: "The administration proposed cutting the HHS discretionary budget by nearly one-fourth, from $127 billion to $95 billion — a $32 billion decrease. The cuts targeted public health programs, research funding, and healthcare safety net programs while preserving RFK Jr.'s 'Make America Healthy Again' initiatives.",
      sources: [
        { name: 'Fierce Healthcare', url: 'https://www.fiercehealthcare.com/regulatory/unpacking-25-hhs-budget-cut-proposed-trump-administration' },
        { name: 'KFF', url: 'https://www.kff.org/other-health/tracking-key-hhs-public-health-policy-actions-under-the-trump-administration/' },
      ],
      isBreaking: false,
    },
  ],
};
